import { OrbitAdd } from '#components/atoms/illustrations/OrbitAdd.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

/**
 * {@link EmptyCertificateAuthorities} is an empty state for the CertificateAuthoritiesPage, which probably should never be reached.
 */
export function EmptyCertificateAuthorities() {
  return (
    <CenteredLayout Illustration={OrbitAdd}>
      <h2 className="h3 mb-8">You don’t have any certificate authorities yet</h2>
      <p className="p">
        Contact us via Slack or{' '}
        <a className="a" href="mailto:info@defined.net">
          info@defined.net
        </a>
      </p>
    </CenteredLayout>
  );
}
